import { StyledInput } from "./style";

export default function Input({ ...props }) {
  return <StyledInput {...props} />;
}
